<app-generic-label
    class="label theme-light"
    [label]="option.label"
    [fit]="mode === 'summary' ? 'fixed' : 'auto'"
    [opaque]="true"
    [pinDraggable]="mode === 'edit'"
    [tagDraggable]="mode === 'edit'"
    [isCollapsed]="collapsed"
    [descriptionCollapsed]="false"
    [hasContent]="true"
    [sequence]="sequence"
    (labelUpdated)="handleLabelUpdated($event)"
    (offsetUpdated)="handleOffsetUpdated($event)">

    <div class="label__body" label-body>

        <!-- edit form view -->
        <app-quiz-label-anatomy-select
            [outline]="false"
            [hidden]="mode === 'summary'"
            [options]="options"
            [formControl]="control">
        </app-quiz-label-anatomy-select>

        <!-- summary view -->
        <div *ngIf="mode === 'summary'" class="label__summary flex items-start" [ngSwitch]="correct">
            <app-icon class="label__icon label__icon--correct" style="font-size: 16px" icon="check-circle" *ngSwitchCase="true"></app-icon>
            <app-icon class="label__icon label__icon--incorrect" style="font-size: 16px" icon="times-circle" *ngSwitchCase="false"></app-icon>
            
            <div class="pl-2 text-12 text-semibold">
                {{ getSelectedLabel(options, control.value)?.title }}
            </div>
        </div>

    </div>

</app-generic-label>